import {
  createBlocContext,
  createBlocProvider
} from "@kernel/frontend-react-app";
import { ToolboxBloc } from "./ToolboxBloc";
import { useContext } from "react";

export const ToolboxContext = createBlocContext<ToolboxBloc>();

export function useToolboxContext() {
  const ctx = useContext(ToolboxContext);
  return ctx;
}

export const ToolboxBlocProvider = createBlocProvider<ToolboxBloc>(
  ToolboxBloc.create(),
  ToolboxContext
);
